<template>
  <div class="modal-hut-rewards-notify container-new-ui">
    <button type="button" class="close close-left position-absolute" data-dismiss="modal" aria-label="Close" @click="cancelAction()">
      <span aria-hidden="true">×</span>
    </button>
    <!-- title wrap -->
    <div class="mb-24 ">
      <div v-if="title" class="modal-notify-title d-flex align-items-center mb-3" :style="alignTitle && `text-align: ${alignTitle}; justify-content: ${alignTitle}`">
        <img v-if="iconTitle" :src="iconTitle" alt="icon" class="mr-3">
        <h2 class="my-0">{{title}}</h2>
      </div>
      <div v-if="imgLogo" class="text-center">
        <img :src="imgLogo" alt="" width="185">
      </div>
    </div>
    <!-- title wrap -->
    <!-- content wrap -->
    <div class="modal-notify-content">
      <div class="modal-text" v-if="text" v-html="text"></div>
      <div class="information-slices-box" v-if="giftRewards && giftRewards.type && giftRewards.slices > 0">
        <div class="d-flex justify-content-center align-items-center mb-3">
          <img src="https://static.phdvasia.com/jp/header/icon-red-slice.svg" alt="" width="26" class="mr-3">
          <h2 class="m-0">{{giftRewards.slices > 1 ? $t('n_slice', {slice: giftRewards.slices}) : $t('one_slice', {slice: giftRewards.slices})}}</h2>
        </div>
        <div class="text-center" v-html="giftRewards.text" style="font-size: 12px"></div>
      </div>
    </div>
    <!-- content wrap -->
    <!-- bottom action -->
    <div class="modal-action-hut mt-24">
      <button
        v-if="btnTitleAction"
        class="active-button-hut btn btn--primary btn--lg w-full"
        @click="handleAction()"
      >
        <span :class="$i18n.locale == $const.LANG_JP && 't14'">{{btnTitleAction}}</span>
      </button>
      <button
        v-if="btnTitleCancel"
        class="default-button-cancel btn btn--secondary mt-10 btn--lg w-full"
        @click="cancelAction()"
      >
        <span :class="$i18n.locale == $const.LANG_JP && 't14'">{{btnTitleCancel || $t("btn_cancel")}}</span>
      </button>
    </div>
    <!-- bottom action -->
  </div>
</template>
<script>

export default {
  name: 'popupNotifyHut',
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    iconTitle: {
      type: String,
      default: ''
    },
    alignTitle: {
      type: String,
      default: 'center'
    },
    imgLogo: {
      type: String,
      default: ''
    },
    giftRewards: {
      type: Object,
      default: () => {}
    },
    btnTitleAction: {
      type: String,
      default: ''
    },
    fncAction: {
      type: Function,
      default: () => {}
    },
    btnTitleCancel: {
      type: String,
      default: ''
    },
    fncCancel: {
      type: Function,
      default: () => {}
    }
  },
  mounted () {
  },
  methods: {
    handleAction () {
      this.$emit('close')
      if (this.fncAction) {
        this.fncAction()
      }
    },
    cancelAction () {
      this.$emit('close')
      if (this.fncCancel) {
        this.fncCancel()
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/popup/PopupNotifyHut.vue